import { render, staticRenderFns } from "./Interregional_analysis_right.vue?vue&type=template&id=495720b7&scoped=true"
import script from "./Interregional_analysis_right.vue?vue&type=script&lang=js"
export * from "./Interregional_analysis_right.vue?vue&type=script&lang=js"
import style0 from "./Interregional_analysis_right.vue?vue&type=style&index=0&id=495720b7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495720b7",
  null
  
)

export default component.exports